export default "__VITE_ASSET__B_iYKrPB__"